import { prefersReducedMotion } from '@theme/utilities';

/**
 * Floating scroll-to-top button (V3 parity).
 */
class BackToTop extends HTMLElement {
  /** @type {number} */
  #scrollThresholdRatio = 0.2;

  /** @type {(() => void) | undefined} */
  #onScroll;

  connectedCallback() {
    this.#scrollThresholdRatio = Number.parseFloat(this.dataset.scrollThreshold || '0.2');
    if (!Number.isFinite(this.#scrollThresholdRatio)) {
      this.#scrollThresholdRatio = 0.2;
    }

    const button = this.querySelector('button');
    button?.addEventListener('click', this.#scrollToTop);

    this.#onScroll = () => this.#updateVisibility();
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#updateVisibility();
  }

  disconnectedCallback() {
    if (this.#onScroll) {
      window.removeEventListener('scroll', this.#onScroll);
    }
  }

  #scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion() ? 'instant' : 'smooth',
    });
  };

  #updateVisibility() {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0) {
      this.dataset.visible = 'false';
      return;
    }

    const ratio = Math.min(Math.max(this.#scrollThresholdRatio, 0), 1);
    const threshold = ratio * scrollable;
    this.dataset.visible = window.scrollY > threshold ? 'true' : 'false';
  }
}

if (!customElements.get('back-to-top-button')) {
  customElements.define('back-to-top-button', BackToTop);
}
